module.exports = new __parcel__URL__("Assembly.df76eb51.jpg").toString();